module.exports = __webpack_public_path__ + "static/media/dq-logo.5319676a.png";